// extracted by mini-css-extract-plugin
export default {"container":"style_container__3XFzL","image":"style_image__TAcWQ","title":"style_title__ZeVTz","subtitle":"style_subtitle__SKYlK"};